import { handleActions, combineActions } from 'redux-actions'
import * as authActions from '../actions/auth'
import * as userActions from '../actions/user'

const initialState = {
  userInfo: {
    data: null,
    loading: false,
    failed: false,
    succeed: false
  },
  addresses: {
    data: [],
    loading: false,
    failed: false,
    succeed: false
  },
  cards: {
    data: [],
    loading: false,
    failed: false,
    succeed: false
  }
}

export default handleActions(
  {
    [combineActions(
      authActions.logIn,
      authActions.signUp,
      userActions.getUserInfo
    )]: state => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        loading: true,
        succeed: false,
        failed: false
      }
    }),
    [combineActions(
      authActions.logInSuccess,
      authActions.signUpSuccess,
      userActions.getUserInfoSuccess
    )]: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        data: action.payload,
        loading: false,
        succeed: true,
        failed: false
      }
    }),
    [combineActions(
      authActions.logInFail,
      authActions.signUpFail,
      userActions.getUserInfoFail
    )]: state => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        loading: false,
        succeed: false,
        failed: true
      }
    }),
    [combineActions(
      userActions.getCards,
      userActions.createCard,
      userActions.removeCard
    )]: (state, action) => ({
      ...state,
      cards: {
        ...state.cards,
        loading: true,
        failed: false,
        succeed: false
      }
    }),
    [combineActions(
      userActions.getCardsSuccess,
      userActions.removeCardSuccess
    )]: (state, action) => ({
      ...state,
      cards: {
        ...state.cards,
        data: action.payload,
        loading: false,
        failed: false,
        succeed: true
      }
    }),
    [userActions.createCardSuccess]: (state, action) => ({
      ...state,
      cards: {
        ...state.cards,
        data: [...state.cards.data, action.payload],
        loading: false,
        failed: false,
        succeed: true
      }
    }),
    [combineActions(
      userActions.getCardsFail,
      userActions.createCardFail,
      userActions.removeCardFail
    )]: (state, action) => ({
      ...state,
      cards: {
        ...state.cards,
        loading: false,
        failed: true,
        succeed: false
      }
    }),
    [combineActions(
      userActions.getAddresses,
      userActions.createAddress,
      userActions.updateAddress,
      userActions.removeAddress
    )]: state => ({
      ...state,
      addresses: {
        ...state.addresses,
        loading: true,
        failed: false,
        succeed: false
      }
    }),
    [combineActions(
      userActions.getAddressesSuccess,
      userActions.removeAddressSuccess
    )]: (state, action) => ({
      ...state,
      addresses: {
        ...state.addresses,
        data: action.payload.filter(address => address.id),
        loading: false,
        failed: false,
        succeed: true
      }
    }),
    [combineActions(
      userActions.getAddressesFail,
      userActions.createAddressFail,
      userActions.updateAddressFail,
      userActions.removeAddressFail
    )]: state => ({
      ...state,
      addresses: {
        ...state.addresses,
        loading: false,
        failed: true,
        succeed: false
      }
    }),
    [userActions.createAddressSuccess]: (state, action) => ({
      ...state,
      addresses: {
        ...state.addresses,
        data: [...state.addresses.data, action.payload],
        loading: false,
        failed: false,
        succeed: true
      }
    }),
    [userActions.updateAddressSuccess]: (state, action) => {
      const addresses = state.addresses.data
      const updatedAddressIndex = addresses.findIndex(
        address => address.id === action.payload.id
      )

      if (updatedAddressIndex !== -1) {
        return {
          ...state,
          addresses: {
            ...state.addresses,
            data: [
              ...addresses.slice(0, updatedAddressIndex),
              action.payload,
              ...addresses.slice(updatedAddressIndex + 1)
            ],
            loading: false,
            failed: false,
            succeed: true
          }
        }
      }

      return state
    }
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/store/reducers/user.js